"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultTemplateReadService = exports.BaseTemplateReadService = exports.TemplateReadService = void 0;
const effect_1 = require("effect");
const requests_1 = require("./requests");
const gavelConfig_1 = require("../gavelConfig");
const FetchHttpClient = __importStar(require("@effect/platform/FetchHttpClient"));
const HttpClient = __importStar(require("@effect/platform/HttpClient"));
class TemplateReadService extends effect_1.Context.Tag('@fixtuur/gavel/TemplateReadService')() {
}
exports.TemplateReadService = TemplateReadService;
const makeTemplateReadService = effect_1.Effect.gen(function* () {
    const config = yield* gavelConfig_1.GavelConfig;
    const http = yield* HttpClient.HttpClient;
    const getById = (id, tenant) => config.baseUrl.pipe(effect_1.Effect.flatMap(baseUrl => effect_1.Effect.request((0, requests_1.GetTemplateById)({ baseUrl, id, tenant }), (0, requests_1.GetTemplateByIdResolver)(http))));
    const getAllTemplatesWithoutSpaces = (tenantId, pagination) => config.baseUrl.pipe(effect_1.Effect.flatMap(baseUrl => effect_1.Effect.request(new requests_1.GetTemplates({ baseUrl, pagination, tenantId, noSpace: true }), (0, requests_1.GetTemplatesResolver)(http))));
    return { getById, getAllTemplatesWithoutSpaces };
});
exports.BaseTemplateReadService = effect_1.Layer.effect(TemplateReadService, makeTemplateReadService);
exports.DefaultTemplateReadService = exports.BaseTemplateReadService.pipe(effect_1.Layer.provide(FetchHttpClient.layer));
